import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=11820395&scoped=true"
import script from "./EditDialog.ts?vue&type=script&lang=ts&external"
export * from "./EditDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11820395",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11820395')) {
      api.createRecord('11820395', component.options)
    } else {
      api.reload('11820395', component.options)
    }
    module.hot.accept("./EditDialog.vue?vue&type=template&id=11820395&scoped=true", function () {
      api.rerender('11820395', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Masters/components/EditDialog/EditDialog.vue"
export default component.exports